// extracted by mini-css-extract-plugin
module.exports = {"BlogGrid":"styles_BlogGrid___nuRj","articlesWrapper":"styles_articlesWrapper__06sse","footer":"styles_footer__iyKW9"};